
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 41 39","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.438 36.055V2.903l-13.903 9.569v14.014l13.902 9.569zM2 26.01h8.534V12.947H2V26.01zM27.902.115a1 1 0 01.535.885v36.957a1 1 0 01-1.567.825L11.223 28.01H1.002a1 1 0 01-1-1V11.947a1 1 0 011-1h10.221L26.872.177a1 1 0 011.032-.062zm5.06 1.321c9.949 9.948 9.948 26.137 0 36.084a.997.997 0 01-1.414 0 .999.999 0 010-1.414c9.169-9.169 9.169-24.087 0-33.256a1 1 0 111.415-1.413zM31.55 26.798a.999.999 0 010-1.414c3.256-3.256 3.256-8.554 0-11.811a1 1 0 111.414-1.414c4.036 4.036 4.036 10.604 0 14.639a.997.997 0 01-1.414 0z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    